var map = {
	"./CustomPackage/routes": "Px6q",
	"./GlobalBPOCore/routes": "jhvR",
	"./SelfService/routes": "72fL",
	"./SteelOApp/routes": "jvqH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gnyb";


//////////////////
// WEBPACK FOOTER
// ./src/customization ^\.\/.*\/routes$
// module id = gnyb
// module chunks = 0